/* eslint-disable jsx-a11y/label-has-associated-control */
import { type FC, useState } from 'react'
import { type BusinessListingFiltersProps } from './BusinessListingFilters.interface'
import styles from './BusinessListingFilters.module.scss'
import { Tag } from '../Tag/Tag'
import { Button } from '../Button/Button'
import { Icon } from '~/components/Icon/Icon'

export const BusinessListingFilters: FC<BusinessListingFiltersProps> = ({
  total,
  sortBy,
  type,
  categories,
  setListView,
  listView
}) => {
  const [activeType] = useState(type.value)
  const [activeCategories] =
  useState(categories.map((category) => category.value))
  const [activeSortBy] = useState(sortBy.options
    .filter((item) => item.selected)
    .map((item) => item.value).toString())

  const redirectToUpdatedSearch = (newCategories: string[], newSortBy: string): void => {
    const searchParams = new URLSearchParams()
    searchParams.set('categories', newCategories.join(','))
    searchParams.set('orderBy', newSortBy)
    window.location.href = `/businesses/${activeType}?${searchParams.toString()}`
  }

  const handleFiltersUpdate = (value: string): void => {
    const newCategories = activeCategories.filter((item) => item !== value)
    redirectToUpdatedSearch(newCategories, activeSortBy)
  }

  const handleSortByUpdate = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const newSortBy = e.target.value
    redirectToUpdatedSearch(activeCategories, newSortBy)
  }

  return (
    <div className={styles.container}>
      <div className={styles.filters}>
        Filters:
        <ul className={styles['filters-list']}>
          <li>
            <Tag
              small
              variant="secondary"
            >
              {type.name}
            </Tag>
          </li>
          {categories.map((category, index) => (
          // eslint-disable-next-line react/no-array-index-key
            <li key={index}>
              <Tag
                small
                variant="secondary"
                type="button"
                onClick={() => { handleFiltersUpdate(category.value) }}
                value={category.value}
                remove
              >
                {category.name}
              </Tag>
            </li>
          ))}
        </ul>
      </div>
      <div className={styles.sort}>
        <div className={styles.results}>
          {total}
          {' '}
          results
        </div>
        <div className={styles.sortby}>
          <label htmlFor="sortBy" className={styles['sortby-label']}>
            Sort by:
          </label>
          <select
            id="sortBy"
            name="sortBy"
            value={activeSortBy}
            className={styles['sortby-select']}
            title={sortBy.label}
            onChange={handleSortByUpdate}
          >
            {sortBy.options.map((option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div className={styles['map-toggle']}>
          <Button
            size="xsmall"
            onClick={() => { setListView && setListView(!listView) }}
          >
            {!listView
              ? (
                <>
                  <Icon name="#map-pin" className={styles['button-icon']} />
                  Map view
                </>
                )
              : (
                <>
                  <Icon name="#list" className={styles['button-icon']} />
                  List view
                </>
                )}
          </Button>
        </div>
      </div>
    </div>
  )
}
